import type { ReactNode } from 'react'

import type { ChatStatusMessageItemState } from './types/ChatStatusMessageTypes'
import type { StatusMessageType } from '@/ui/components/StatusMessage/types/StatusMessageTypes'

interface StatusItemProps {
    state?: ChatStatusMessageItemState
    type?: StatusMessageType
    // the line below the item goes on to the message that follows the status
    connectToFollowUp?: boolean
    children: ReactNode
}

// The frame of one item of the status: its state, its type and the connection to what follows are classes here
const StatusItem = ({ state = 'done', type, connectToFollowUp = false, children }: StatusItemProps) => (
    <div className={`chat-status-message-item -${state}${type ? ` -type-${type}` : ''}${connectToFollowUp ? ' --connect-follow-up' : ''}`}>
        {children}
    </div>
)

export default StatusItem
